module.exports = __webpack_public_path__ + "media/images/participantes-a215ab5bc6cb633e02261a853b789380.png";